import eventsGetters from "./getters.js";
import eventsMutations from "./mutations.js";
import eventsActions from "./actions.js";

export default {
  namespaced: true,
  state() {
    return {
      eventsTimestamp: null,
      events: [],
    };
  },
  getters: eventsGetters,
  mutations: eventsMutations,
  actions: eventsActions,
};
